import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrainingStatusComponent } from './training-status/training-status.component';

const routes: Routes = [
  { path: '', component: TrainingStatusComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule { }
